/**
 * Une clases ignorando lo vacío.
 *
 * Los CSS Modules tipan cada clase como `string | undefined`, así que
 * interpolarlas en una plantilla mete "undefined" en el atributo `class`.
 */
export function cx(...names: readonly (string | false | undefined)[]): string {
  return names.filter((name) => typeof name === 'string' && name !== '').join(' ');
}
